import { useMemo, useCallback } from 'react'
import getOfferFeatureIcon from 'lib/offer/getOfferFeatureIcon'
import ToggleButton from 'LuxKit/ToggleButton'
import { CRUISE_AMENITY_CATEGORIES_REGEX } from 'constants/cruise'

const facilityCategoryIconMap: Record<string, App.OfferFeatureSymbol> = {
  food: 'cook',
  dining: 'crossed_utensils',
  entertainment: 'tv',
  wellness: 'lotus',
  family: 'childs_face',
  activities: 'pool',
  bars: 'martini_glass',
  shopping: 'tag',
  technology: 'internet_connection',
  accommodation: 'bed',
  enrichment: 'line_university',
  specifications: 'line_ship',
  services: 'line_key_skeleton',
  other: 'check',
}

export function getIconCategory(content: string): string {
  const normalized = content.toLowerCase()

  if (CRUISE_AMENITY_CATEGORIES_REGEX.FOOD.test(normalized)) return 'food'
  if (CRUISE_AMENITY_CATEGORIES_REGEX.DINING.test(normalized)) return 'dining'
  if (CRUISE_AMENITY_CATEGORIES_REGEX.ENTERTAINMENT.test(normalized)) return 'entertainment'
  if (CRUISE_AMENITY_CATEGORIES_REGEX.WELLNESS.test(normalized)) return 'wellness'
  if (CRUISE_AMENITY_CATEGORIES_REGEX.FAMILY.test(normalized)) return 'family'
  if (CRUISE_AMENITY_CATEGORIES_REGEX.ACTIVITIES.test(normalized)) return 'activities'
  if (CRUISE_AMENITY_CATEGORIES_REGEX.BARS.test(normalized)) return 'bars'
  if (CRUISE_AMENITY_CATEGORIES_REGEX.SHOPPING.test(normalized)) return 'shopping'
  if (CRUISE_AMENITY_CATEGORIES_REGEX.TECHNOLOGY.test(normalized)) return 'technology'
  if (CRUISE_AMENITY_CATEGORIES_REGEX.ACCOMMODATION.test(normalized)) return 'accommodation'
  if (CRUISE_AMENITY_CATEGORIES_REGEX.ENRICHMENT.test(normalized)) return 'enrichment'
  if (CRUISE_AMENITY_CATEGORIES_REGEX.SPECIFICATIONS.test(normalized)) return 'specifications'
  if (CRUISE_AMENITY_CATEGORIES_REGEX.SERVICES.test(normalized)) return 'services'
  if (CRUISE_AMENITY_CATEGORIES_REGEX.PUBLIC_AREAS.test(normalized)) return 'public_areas'

  return 'other'
}

interface Props {
  category: string
  isSelected: boolean
  onSelect: (category: string) => void
}

function CruiseShipAmenitiesTab({
  category,
  isSelected,
  onSelect,
}: Props) {
  const Icon = useMemo(() => {
    const iconCategory = getIconCategory(category)
    const iconName = facilityCategoryIconMap[iconCategory || 'other']

    return getOfferFeatureIcon(iconName)
  }, [category])

  const handleTabClick = useCallback(() => {
    onSelect(category)
  }, [onSelect, category])

  const title = useMemo(() => {
    return category.charAt(0).toUpperCase() + category.slice(1)
  }, [category])

  return <ToggleButton
    key={`tab-amenity-${category}`}
    data-option={category}
    kind="primary"
    startIcon={<Icon />}
    title={title}
    orientation="vertical"
    isSelected={isSelected}
    onClick={handleTabClick}
  />
}

export default CruiseShipAmenitiesTab
